import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import CreditorMailing from './CreditorMailing';

const emptyProps = {
  case_uuid: 'azbtest_2644',
  purchase_right_away: false,
  creditor_mailing: {},
  dataReady: true,
  dispatch: null,
  lastUpdated: 1000,
  error: null,
  receipt: null,
};

const pdfDocumentCreditorMailingesProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  creditor_mailing: {
    meta: {
      case_uuid: 'azbtest_2644',
      csv: { title: 'Buy Raw Data' },
      pdf: {
        friendly_name: 'Bankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.pdf',
        timestamp: 1548766827.20697,
        link: 'http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/creditor_mailing/pdf-D9081DB4-23C5-11E9-9E16-881D5B15AC09?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.pdf&AWSAccessKeyId=proxy_dummy_key&Expires=1864386051&Signature=Mzh8i7OqbncdVTcw9snJF64oITg%3D',
        title: 'Buy 3 Column Format',
      },
      timestamp: 1548767636.12717,
    },
    text: null,
  },
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
};

const csvDocumentCreditorMailingesProps = {
  case_uuid: 'azbtest_2644',
  dataReady: true,
  receipt: null,
  lastUpdated: 1000,
  error: null,
  creditor_mailing: {
    meta: {
      case_uuid: 'azbtest_2644',
      csv: {
        friendly_name: 'Bankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.csv',
        timestamp: 1548767636.12717,
        link: 'http://aws-s3.inforuptcy.dev.azk.io/inforuptcy-storage/pacer/azbtest/2644/creditor_mailing/csv-BB616C1E-23C7-11E9-9E16-881D5B15AC09?response-content-disposition=attachment%3B+filename%3DBankr.D.Ariz.TEST_2-07-bk-00012_creditor_matrix.csv&AWSAccessKeyId=proxy_dummy_key&Expires=1864386887&Signature=BP5pPLPCOzl0Bgi%2FVKtWCDUovdw%3D',
        title: 'Buy Raw Data',
      },
      pdf: {
        title: 'Buy 3 Column Format',
      },
    },
    text: `2:07-bk-00012-BMW,FIRST TIME MORTGAGE ,4545 N NORTHERN AVE,"PHOENIX, AZ 85112 ",,,,
    2:07-bk-00012-BMW,"U.S. Bankruptcy Court, Arizona","230 North First Avenue, Suite 101","Phoenix, AZ 85003-1727", ,,,
    2:07-bk-00012-BMW,ABC BANK ,123 N. CENTRAL AVE.,"PHOENIX, AZ 85001", ,,,
    2:07-bk-00012-BMW,AMERICAN EXPRESS ,P.O. BOX 3024,MALVERN PA 19355-0701, ,,,
    2:07-bk-00012-BMW,AMEX ,P.O. BOX 7871,FORT LAUDERDALE FL 33329, ,,,
    2:07-bk-00012-BMW,BENEFICIAL/HFC ,2700 SANDERS RD,PROSPECT HEIGHTS IL 60070, ,,,
    2:07-bk-00012-BMW,Bloomingdales ,PO Box 8745,New York NY 10012-8745, ,,,
    2:07-bk-00012-BMW,CHASE CHASE BANK ,P.O. BOX 52195,PHOENIX AZ 85072-2195, ,,,
    2:07-bk-00012-BMW,CITICORP TRUST BANK ,1190 WINTERSON ROAD ST.,LINTHICUM HEIGHTS MD 21090, ,,,
    2:07-bk-00012-BMW,CROSS COUNTRY BANK ,P.O. BOX 222222,HUNTINGTON WV 25770, ,,,
    2:07-bk-00012-BMW,Carr & Masterson Fine Jewelry ,908 North Michigan Ave.,Chicago IL 60669, ,,,
    2:07-bk-00012-BMW,Chase Bank ,1900 Central St.,Evanston IL 60201, ,,,
    2:07-bk-00012-BMW,Citibank VISA ,PO Box 198,Sioux Falls SD 57188-1234, ,,,
    2:07-bk-00012-BMW,DILLARD NATIONAL BANK ,PO BOX 52005,PHOENIX AZ 85072, ,,,
    2:07-bk-00012-BMW,DIRECT MERCHANTS BANK ,P.O. BOX 60142,CITY OF INDUSTRY CA 91716-0142, ,,,
    2:07-bk-00012-BMW,DISCOVER CARD ,P.O. BOX 30395,SALT LAKE CITY UT 84130, ,,,
    2:07-bk-00012-BMW,Davis Department Store ,PO Box 909,Portland OR 87655, ,,,
    2:07-bk-00012-BMW,Debbie&#039;s Catering ,121 Augusta Lane,Suite 8,Park Ridge IL 60356, ,,
    2:07-bk-00012-BMW,Don&#039;s Lawns ,1340 Green Bay Road,Suite 963,Kenosha WI 67896, ,,
    2:07-bk-00012-BMW,First City Bank ,560 North Michigan Avenue,Chicago IL 60604, ,,,
    2:07-bk-00012-BMW,GMAC Finance ,1700 Greenbay Road,Wilmette IL 63221, ,,,
    2:07-bk-00012-BMW,Honda Finance ,1323 Santa Vista,Orosi CA 93647, ,,,
    2:07-bk-00012-BMW,IRS ,230 S. Dearborn St.,Chicago IL 60604, ,,,
    2:07-bk-00012-BMW,Jan and Elwood Smith , ,,,,,
    2:07-bk-00012-BMW,Minor Child ,143 W Arthur Blvd.,Chicago IL 60657, ,,,
    2:07-bk-00012-BMW,SUE TEST ,345 N. 1ST ST.,"PHOENIX, AZ 85003", ,,,
    2:07-bk-00012-BMW,Sallie Mae Servicing ,P.O. Box 9532,Wilkes Barre PA 18773-9532, ,,,
    2:07-bk-00012-BMW,U.S. Trustee&#039;s Office ,"230 N. First Avenue, Suite 204","Phoenix, AZ 85003 ",,,,
    2:07-bk-00012-BMW,JAMES J. GENTILE ,"JAMES J. GENTILE, PC","5355 W. CHANDLER BLVD., &#035;7","CHANDLER, AZ 85226 ",,,
    2:07-bk-00012-BMW,Joseph Wayne Sample ,PO BOX 123,"CHANDLER, AZ 85226 ",,,,n
    2:07-bk-00012-BMW,Sarah Lynn Sample ,PO BOX 123,"CHICAGO, IL 60605-0123 ",,,,
    2:07-bk-00012-BMW,Sue Test ,"Sue&#039;s Law Firm, PC","333 N. 3rd St, &#035;100","Phoenix, AZ 85000 ",,,`,
  },
  dispatch: () => action('dispatch'),
  purchaseData: () => action('purchaseData'),
};

storiesOf('Case Menu/CreditorMailing', module)
  .add('Loading', () => (
    <div>
      <h3>Component can be in a loading state while we fetch data</h3>
      <hr />
      <CreditorMailing />
    </div>
  ))
  .add('View', () => (
    <div>
      <h3>By default, buttons for buy pdf and csv formats </h3>
      <hr />
      <h4>On click 'Buy 3 Column Format' pacer is contacted for purchase of pdf format.</h4>
      <h4>On click 'Buy Raw Data' pacer is contacted for purchase of csv format.</h4>
      <hr />

      <CreditorMailing
        {...emptyProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))

  .add('Buy 3 Column Format', () => (
    <div>
      <h3>Buy 3 Column Format - pdf format of the document </h3>
      <hr />
      <h4>Document can be updated by pressing the 'Buy 3 Column Format' button on the left side.</h4>
      <h4>Right side has updated date and download link with icons for pdf.</h4>
      <h4>Updated date has date of an update and amount of time passed from the update.</h4>
      <h4>Bottom of the page contains textarea with Raw Data ready to be copied.</h4>
      <hr />

      <CreditorMailing
        {...pdfDocumentCreditorMailingesProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ))

  .add('Buy Raw Data', () => (
    <div>
    <h3>Buy Raw Data - csv format of the document </h3>
    <hr />
    <h4>Document can be updated by pressing the 'Buy Raw Data' button on the left side.</h4>
    <h4>Right side has updated date and download link with icons for csv.</h4>
    <h4>Updated date has date of an update and amount of time passed from the update.</h4>
    <hr />

      <CreditorMailing
        {...csvDocumentCreditorMailingesProps}
        purchaseData={action('purchaseData')}
       />
    </div>
  ));




// WEBPACK FOOTER //
// ./src/components/case/creditor_mailing/CreditorMailing.stories.jsx